import { z } from 'zod'
// Explicit `.ts` extension is required by Supabase Edge Runtime (Deno) — relative imports
// must include the file extension. TypeScript consumers of this module need
// `allowImportingTsExtensions: true` in their tsconfig (already set in packages/shared,
// packages/tasks, apps/web).
import { EMAIL_TYPES } from './types.ts'
import { emailSchema } from '../schemas/email.ts'

/**
 * Wire schema for the email send payload.
 * The caller validates `variables` against the per-type schema after parsing this envelope.
 * `to` resolves to the branded `Email` type after Zod transforms (trim + lowercase + format check).
 */
export const emailSendPayloadSchema = z.object({
  type: z.enum(EMAIL_TYPES),
  to: emailSchema,
  /** Registry-defined template variables; shape depends on `type`. */
  variables: z.record(z.unknown()),
  /** Source row (e.g. invitation id) used for correlation in email_events. */
  sourceId: z.string().min(1),
  /** Bumped on resend so the idempotency key changes. Defaults to 1. */
  version: z.number().int().positive().default(1),
})

export type EmailSendPayload = z.infer<typeof emailSendPayloadSchema>
